import React from 'react';
import { CardCloseSVG } from './CardViewSVG';
//import { useSelector, useDispatch } from 'react-redux';
/*import {
  setSelectedCheckedItems,
  setSelectedCheckedRowData,
} from '../../../../../../../redux/member/enrollmentPlanCompareSlice';*/
import {
  ProductIcon,
  ProductDentalIcon,
  ProductVisionIcon,
} from '../../../EnrollmentIconsSvg';
import './CardView.scss';

const CardView = ({
  data,
  selectedCheckedItems,
  selectedCheckedRowData,
  setSelectedCheckedItems,
  setSelectedCheckedRowData,
  selectedTab,
}) => {
  const { planId, planTitle } = data;
  //const dispatch = useDispatch();
  /*const { selectedCheckedItems, selectedCheckedRowData } = useSelector(
    ({ enrollmentPlanCompare }) => enrollmentPlanCompare,
  );*/
  const removeItem = (planID) => {
    /*dispatch(
      setSelectedCheckedItems(
        selectedCheckedItems.filter((id) => id !== planID),
      ),
    );
    dispatch(
      setSelectedCheckedRowData(
        selectedCheckedRowData.filter((item) => item?.planId !== planID),
      ),
    );*/
    setSelectedCheckedItems(selectedCheckedItems.filter((id) => id !== planID));
    setSelectedCheckedRowData(
      selectedCheckedRowData.filter((item) => item?.planId !== planID),
    );
  };

  return (
    <div className="card-container">
      <div
        aria-label="Remove this provider from the selected options"
        className="close-icon"
        onClick={() => removeItem(planId)}
      >
        <CardCloseSVG />
      </div>
      <div className="card-view">
        <div className="content-container">
          <div>
            {selectedTab === 'medical' && (
              <ProductIcon
                classNameSecondary="card-view--icon-secondary"
                classNamePrimary="card-view-icon"
              />
            )}
            {selectedTab === 'dental' && (
              <ProductDentalIcon
                classNameSecondary="card-view--icon-secondary"
                classNamePrimary="card-view-icon"
              />
            )}
            {selectedTab === 'vision' && (
              <ProductVisionIcon
                classNameSecondary="card-view--icon-secondary"
                classNamePrimary="card-view-icon"
              />
            )}
          </div>
          <div className="ml-3 column-last">
            <p className="m-0 plan-name">{planTitle}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardView;
